module.exports = __webpack_public_path__ + "static/img/kx.0b0b7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kx.png
// module id = yGPf
// module chunks = 3